import { render } from "./CEmployeeCollection.vue?vue&type=template&id=4c5c0434&scoped=true"
import script from "./CEmployeeCollection.vue?vue&type=script&lang=js"
export * from "./CEmployeeCollection.vue?vue&type=script&lang=js"

import "./CEmployeeCollection.vue?vue&type=style&index=0&id=4c5c0434&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5c0434"],['__file',"src/components/h5/board/CEmployeeCollection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c5c0434"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c5c0434', __exports__)) {
    api.reload('4c5c0434', __exports__)
  }
  
  module.hot.accept("./CEmployeeCollection.vue?vue&type=template&id=4c5c0434&scoped=true", () => {
    api.rerender('4c5c0434', render)
  })

}


export default __exports__